import { Col, Popover, Row } from 'antd';
import React from 'react'
import styled from 'styled-components'

const ProgressBarComp = ({ style, progressBarProps, showtext, textStyle }) => {

    const colors = {
        gray: 'gray',
        yellow: '#ffff00',
        green: '#28a745'
    }
    const Wrapper = styled.div`
        display: flex;
        width: 100%;
        background-color: #e9ecef;
    `
    const ColorSection = styled.div`
        height: 100%;
        text-align: center;
        min-width: fit-content;
        font-weight: 600;
        display: flex;
        flex-direction: column;
        justify-content: center;
    `
    const Circle = styled.span`
        height: 25px;
        width: 25px;
        border-radius: 50%;
        display: inline-block;
    `
    const content = (
        <>
            {progressBarProps && progressBarProps.map(bar => (
                <Row style={{ padding: '3px' }}>
                    <Col span={12}>
                        <Circle style={{ backgroundColor: colors[bar.bgcolor] }} class="dot"></Circle>
                    </Col>
                    <Col span={12}>
                        <span>{`${bar.taskPercent}%`}</span>
                    </Col>
                </Row>
            ))}
        </>
    );

    return (
        <Popover content={content} title="Tasks Progress Status" >
            <Wrapper style={style}>
                {progressBarProps && progressBarProps.length > 0 &&
                    progressBarProps.map(bar => <ColorSection
                        style={{ backgroundColor: colors[bar.bgcolor], width: `${bar.taskPercent}%` }}>
                        {showtext && bar.taskPercent > 0 &&
                            <>{`${Math.round(bar.taskPercent)}%`}</>
                        }
                    </ColorSection>)}
            </Wrapper>
        </Popover>
    )
}

export default ProgressBarComp;
